<template>
  <div ref="refCartMobile">

    <div class="menu-bordered" v-if="getB2bEnabled" ref="bottomNav">
      <div class="slide-menu" ref="slideMenu">
        <div
            v-for="(menu, idx) in visibleMenuItems"
            :key="menu.action"
            class="menu-box"
            :class="{selected: isSelected(menu.action) || (menu.action === 'cart' && drawer_cart)}"
            @click="menuClick(menu.action, idx)"
        >
          <div class="icon-container">
            <span
                class="icon-mark"
                :aria-label="menu.text"
            >
              <span class="material-icons big">
                {{ menu.icon }}
              </span>
              <span v-if="menu.action==='cart'" class="badge cart-badge" :class="{ 'badge-pop': badgeAnimate }">{{ getBet.odds.length }}</span>
            </span>
          </div>
          <div class="text">{{ $t(menu.text) }}</div>
        </div>
      </div>
      <transition name="fade-height">
        <search v-if="dialogSearch" />
      </transition>
    </div>

    <!-- ── Backdrop + sidebar sinistra (sport tree) ──────────────────────── -->
    <div @click="menuHandler()" :class="drawer ? 'open' : ''" class="mobile-sidebar-blur-bg left">
<!--      <div class="pl-2 pt-2">-->
<!--        <button class="primary-button" @click="goHome()">-->
<!--          <span class="material-icons">home</span>-->
<!--          <span>{{ $t('home') }}</span>-->
<!--        </button>-->
<!--      </div>-->
<!--      <button class="close-btn" @click.stop="menuHandler()">-->
<!--        <span class="material-icons small">close</span>-->
<!--      </button>-->
    </div>

    <div ref="leftSidebar" class="side-modal revengeBetConsole" :class="drawer ? 'open' : ''" tabindex="-1">
      <div class="top-bar-left-modal" v-if="getGameConsole === 'classic'">
        <button class="primary-button" @click="goHome()">
          <span class="material-icons">home</span>
          <span>{{ $t('home') }}</span>
        </button>
        <button class="platform-button" @click.stop="menuHandler()">
          <span class="material-icons small">close</span>
        </button>
      </div>
      <div class="top-bar-left-modal am" v-else>
        <span>{{ $t('allsports') }}</span>
        <button class="platform-button" @click.stop="menuHandler()">
          <IllinoisIcons icon="close"/>
        </button>
      </div>
      <LeftModule />
    </div>

    <section v-if="getGameConsole === 'classic'">
      <!-- ── Backdrop + sidebar carrello ───────────────────────────────────── -->
      <div @click="cartHandler()" :class="drawer_cart ? 'open' : ''" class="mobile-sidebar-blur-bg"></div>

      <div
          :class="drawer_cart ? 'open' : ''"
          class="side-modal revengeBetConsole cart"
          :style="cartSheetStyle"
          @touchstart="onSheetTouchStart"
          @touchmove="onSheetTouchMove"
          @touchend="onSheetTouchEnd"
          @touchcancel="onSheetTouchEnd"
      >

        <div class="cart-sheet-top" data-sheet-drag>
          <span class="cart-sheet-handle"></span>
          <div class="cart-sheet-header">
            <span class="cart-sheet-title">{{ $t('cartSheet.title') }}</span>
            <button class="cart-sheet-close" :aria-label="$t('close')" @click.stop="cartHandler()">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                <path d="M6 6l12 12M18 6L6 18"/>
              </svg>
            </button>
          </div>
        </div>

        <div class="modal-content" id="modal_cart_content" ref="cartSheetContent">
          <RightModule />
        </div>

      </div>

    </section>
    <section v-else>
<!--      <div @click="cartHandler()" :class="drawer_cart ? 'open' : ''" class="mobile-sidebar-blur-bg"></div>-->

      <template v-if="getGameConsole === 'american'">
        <div
            v-if="drawer_cart"
            class="cart-american-backdrop"
            @click="cartHandler"
        ></div>
        <CartAmerican
            v-if="getBet.odds.length > 0 || drawer_cart"
            ref="cartRef"
            :is-cart-open="drawer_cart"
            @toggle-cart="cartHandler"
        />
      </template>
    </section>


  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import LeftModule from '@/components/Left.vue';
import RightModule from '@/components/Right';
import ActionsMarketView from '@/components/right_widgets/ActionsMarketView';
import IllinoisIcons from "@/components/american/icons.vue";
import CartAmerican from "@/components/american/CartAmerican.vue";

export default {
  name: 'TopNavigationMobile',

  components: {CartAmerican, IllinoisIcons, LeftModule, RightModule, ActionsMarketView },

  // CartMarketView reads this to switch itself and its children to the
  // bottom-sheet layout; the desktop right column never gets it.
  provide() {
    return { cartSheetHost: true };
  },

  data() {
    return {
      drawer:          false,
      drawer_cart:     false,
      badgeAnimate:    false,
      betDetailOpen:   false,
      cartSectionActive: 'bet',
      sheetBottom:       60,
      sheetDragY:        0,
      sheetDragging:     false,
      menu_items: [
        { text: 'generic.sport', icon: 'sports_soccer', action: 'menu' },
        { text: 'live', icon: 'alarm', action: 'live' },
        { text: 'betSlip', icon: 'receipt_long', action: 'cart' }

      ]
    };
  },

  computed: {
    ...mapGetters({
      getBet:                    'cart/getBet',
      getSettings:               'cart/getSettings',
      getTournamentsActive:      'previewPrematch/getTournamentsActive',
      getEventsDetail:           'detailPrematch/getEventsDetail',
      getEventsLiveDetailActive: 'detailLive/getEventsLiveDetailActive',
      getConfirmedBet:           'cart/getConfirmedBet',
      getAppSection:             'ui/getAppSection',
      getGameConsole: 'settings/getGameConsole',
      getB2bEnabled:       'settings/getB2bEnabled'

    }),
    cartSheetStyle() {
      const style = { '--cart-sheet-bottom': this.sheetBottom + 'px' };
      // The bet detail dialog is rendered at the app root (MyBets
      // mountDialogLayer), so the sheet can keep its transform.
      if (this.sheetDragging) {
        style.transform = `translateY(${this.sheetDragY}px)`;
        style.transition = 'none';
      }
      return style;
    },
    visibleMenuItems() {
      return this.menu_items.filter(menu =>
          menu.action !== 'live' || (menu.action === 'live' && this.getSettings.enableLive)
      );
    },
  },

  watch: {
    drawer(isOpen) {
      if (isOpen && this.$refs.leftSidebar) {
        this.$nextTick(() => { this.$refs.leftSidebar.scrollTop = 0; });
      }
    },
    'getBet.odds.length'(newVal, oldVal) {
      // Animazione badge
      if (newVal > oldVal) {
        this.badgeAnimate = false;
        this.$nextTick(() => {
          this.badgeAnimate = true;
          setTimeout(() => { this.badgeAnimate = false; }, 500);
        });
      }
      // Notifica la skin del conteggio aggiornato
      this._notifyParent('SPORT_CART_UPDATED', { count: newVal });
      // Carrello svuotato: chiude il drawer e rimuove no-scroll
      if (newVal === 0 && this.drawer_cart) {
        this.drawer_cart = false;
        this._unlockScroll();
        this.setMobileCartOpen(false);
        this._notifyParent('CART_STATE_CHANGED', { isOpen: false });
      }
    },
  },

  mounted() {
    if (window.openlivesection === 'true' || window.openlivesection === true) {
      this.setViewMode({ mode: 'detail', section: 'live' });
    }

    // ── Listener postMessage dalla skin ─────────────────────────────────────
    // La skin (MobileFooterFixed) invia OPEN_CART / CLOSE_CART / OPEN_TREE / CLOSE_TREE
    // invece di interagire direttamente con questo componente.
    // Intercetta anche openSlug per chiudere eventuali drawer aperti durante
    // la navigazione (es. click Live mentre il tree è aperto).
    this._onSkinMessage = (event) => {
      if (!event.data || typeof event.data !== 'object') return;
      switch (event.data.type) {
        // Se il drawer è già nello stato richiesto la skin ha uno stato
        // vecchio (es. iframe ricaricato dopo il login): lo ri-notifichiamo
        // così il suo bottone si riallinea invece di restare bloccato.
        case 'OPEN_CART':
          if (!this.drawer_cart) this.cartHandler();
          else this._notifyParent('CART_STATE_CHANGED', { isOpen: true });
          break;
        case 'CLOSE_CART':
          if (this.drawer_cart) this.cartHandler();
          else this._notifyParent('CART_STATE_CHANGED', { isOpen: false });
          break;
        case 'OPEN_TREE':
          if (!this.drawer) this.menuHandler();
          else this._notifyParent('TREE_STATE_CHANGED', { isOpen: true });
          break;
        case 'CLOSE_TREE':
          if (this.drawer) this.menuHandler();
          else this._notifyParent('TREE_STATE_CHANGED', { isOpen: false });
          break;
        case 'openSlug': {
          // Chiude i drawer aperti durante la navigazione
          if (this.drawer)      this.menuHandler();
          if (this.drawer_cart) this.cartHandler();
          // Naviga alla live list se richiesto
          if (event.data.page === 'live_list') {
            this.goLive()
          }
          break;
        }
      }
    };
    window.addEventListener('message', this._onSkinMessage);

    // The sheet stops above the bottom nav so the nav stays visible.
    this.$nextTick(() => {
      if (this.$refs.bottomNav && this.$refs.bottomNav.offsetHeight) {
        this.sheetBottom = this.$refs.bottomNav.offsetHeight;
      }
    });

    // Notifica la skin del conteggio corrente appena il componente è montato
    // (la skin potrebbe montarsi dopo l'iframe, quindi usiamo un piccolo delay)
    setTimeout(() => {
      this._notifyParent('SPORT_CART_UPDATED', { count: this.getBet.odds.length });
      // Un iframe appena (ri)caricato ha i drawer chiusi: la skin potrebbe
      // ancora crederli aperti (es. reload dopo il login partito dal carrello).
      this._notifyParent('CART_STATE_CHANGED', { isOpen: this.drawer_cart });
      this._notifyParent('TREE_STATE_CHANGED', { isOpen: this.drawer });
    }, 300);

    // ── Listener eventi interni (da child components) ────────────────────────
    const vm = this;
    this.$root.$on('close_sidebar_left', (value) => {
      if (value && vm.drawer) { vm.menuHandler(); }
    });
    this.$root.$on('close_sidebar_right', (value) => {
      if (value && vm.drawer_cart) { vm.cartHandler(); }
    });
    this.$root.$on('open_sidebar_right', (value) => {
      vm.cartHandler();
    });
    this.$root.$on('bet-detail-open', (val) => {
      vm.betDetailOpen = val;
    });
    this.$root.$on('cart-section-change', (section) => {
      vm.cartSectionActive = section;
    });
    this.$root.$on('sectionCart', () => {
      vm.cartSectionActive = 'bet';
    });
  },

  beforeDestroy() {
    window.removeEventListener('message', this._onSkinMessage);
    this.$root.$off('close_sidebar_left');
    this.$root.$off('close_sidebar_right');
    this.$root.$off('open_sidebar_right');
    this.$root.$off('bet-detail-open');
    this.$root.$off('cart-section-change');
    this.$root.$off('sectionCart');
  },

  methods: {
    ...mapActions({
      setViewMode:           'ui/setViewMode',
      setSubaction:          'ui/setSubaction',
      setMobileCartOpen:     'cart/setMobileCartOpen',
      setProgramOpen:        'settings/setProgramOpen',
      removeFromPreview:     'previewPrematch/removeFromPreview',
      removeFromDetail:      'detailPrematch/removeFromDetail',
      removeEventLiveDetail: 'detailLive/removeEventLiveDetail',
      resetPreviewLive:      'previewLive/resetPreviewLive',
      setActiveTournamentIdLivePreview: 'marketview/setActiveTournamentIdLivePreview',
    }),
    menuClick(action, idx) {
      this.selected = action;
      this.animateIdx = idx;
      this.closeOpenModals(action);
      this.actionDispatcher(action);
    },
    closeOpenModals(exceptAction) {
      if (exceptAction !== 'cart' && this.drawer_cart) {
        this.drawer_cart = false;
        this._unlockScroll();
        this.setMobileCartOpen(false);
      }
      if (exceptAction !== 'menu' && this.drawer) {
        this.drawer = false;
        this.setProgramOpen(false);
      }
    },
    actionDispatcher(action) {
      switch (action) {
        case 'menu': this.menuHandler(); break;
        case 'live': this.goLive(); break;
        case 'casino':
          window.parent.postMessage({ type: 'openCasino' }, '*');
          break;
        case 'cart': this.toggleCart(); break;
        case 'home': this.goHome(); break;
        case 'promotions': this.goPromotions(); break;
      }
    },
    toggleCart() {
      this.drawer_cart = !this.drawer_cart;
      if (this.drawer_cart) {
        this._lockScroll();
      } else {
        this._unlockScroll();
      }
      this.setMobileCartOpen(this.drawer_cart);
    },
    getTotalCountLive() {
      return Object.values(this.getCountLive).reduce((acc, { count }) => acc + count, 0);
    },
    goPromotions(){
      window.parent.postMessage({ type: 'goPromotions' }, '*');

    },

    isSelected(action) {
      return this.selected === action;
    },

    // ── Cart ──────────────────────────────────────────────────────────────────
    cartHandler() {
      this.drawer_cart = !this.drawer_cart;
      if (this.drawer_cart) {
        this._lockScroll();
      } else {
        this._unlockScroll();
      }
      this.setMobileCartOpen(this.drawer_cart);
      // Notifica la skin dello stato (per sincronizzare il bottone "betslip" nel footer)
      this._notifyParent('CART_STATE_CHANGED', { isOpen: this.drawer_cart });
    },

    // ── Swipe down per chiudere il carrello ──────────────────────────────────
    // Parte dalla maniglia/header oppure dal contenuto quando è già in cima;
    // un gesto verso l'alto o orizzontale resta uno scroll normale.
    onSheetTouchStart(e) {
      if (!this.drawer_cart || this.betDetailOpen || e.touches.length !== 1) return;
      const target = e.target;
      if (target.closest && target.closest('input, textarea, select, .custom-keyboard-accordion')) return;
      const fromHandle = !!(target.closest && target.closest('[data-sheet-drag]'));
      const content = this.$refs.cartSheetContent;
      this._sheetTouch = {
        startX: e.touches[0].clientX,
        startY: e.touches[0].clientY,
        startTime: Date.now(),
        allowed: fromHandle || !content || content.scrollTop <= 0,
        decided: false,
      };
    },
    onSheetTouchMove(e) {
      const t = this._sheetTouch;
      if (!t || !t.allowed) return;
      const dx = e.touches[0].clientX - t.startX;
      const dy = e.touches[0].clientY - t.startY;
      if (!t.decided) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        t.decided = true;
        if (dy <= 0 || Math.abs(dx) > Math.abs(dy)) {
          t.allowed = false;
          return;
        }
        this.sheetDragging = true;
      }
      if (e.cancelable) e.preventDefault();
      this.sheetDragY = Math.max(0, dy);
    },
    onSheetTouchEnd() {
      const t = this._sheetTouch;
      this._sheetTouch = null;
      if (!t || !this.sheetDragging) return;
      const velocity = this.sheetDragY / Math.max(1, Date.now() - t.startTime);
      const shouldClose = this.sheetDragY > 120 || (this.sheetDragY > 50 && velocity > 0.5);
      this.sheetDragging = false;
      this.sheetDragY = 0;
      if (shouldClose) this.cartHandler();
    },

    // ── Tree / menu sinistro ──────────────────────────────────────────────────
    menuHandler() {
      this.drawer = !this.drawer;
      this.setProgramOpen(this.drawer);
      // Notifica la skin dello stato (per sincronizzare il bottone "menu" nel footer)
      this._notifyParent('TREE_STATE_CHANGED', { isOpen: this.drawer });
    },

    // ── Home ──────────────────────────────────────────────────────────────────
    goHome() {
      const detailSources = (this.getEventsDetail || []).map(e => e.source).filter(Boolean);
      detailSources.forEach(source => this.removeFromDetail({ source }));

      const previewSources = [...(this.getTournamentsActive || [])];
      previewSources.forEach(source => this.removeFromPreview({ source }));

      const liveSources = [...(this.getEventsLiveDetailActive || [])];
      liveSources.forEach(source => this.removeEventLiveDetail(source));

      // Live-scoped: left set, it kept the prematch home filtered by the live
      // tree's tournament, and kept filtering after a sport change too.
      this.setActiveTournamentIdLivePreview([]);
      this.resetPreviewLive();
      this.setViewMode({ mode: 'preview' });
      this.setSubaction('home');
      window.parent.postMessage({ type: 'removeSlugs' }, '*');
      window.scrollTo({ top: 0, behavior: 'smooth' });

      if (this.drawer) this.menuHandler();
    },
    goLive() {
      // Close all open prematch details
      const detailSources = (this.getEventsDetail || []).map(e => e.source).filter(Boolean);
      detailSources.forEach(source => this.removeFromDetail({ source }));

      // Close all open prematch previews
      const previewSources = [...(this.getTournamentsActive || [])];
      previewSources.forEach(source => this.removeFromPreview({ source }));

      // Close all open live details
      const liveSources = [...(this.getEventsLiveDetailActive || [])];
      liveSources.forEach(source => this.removeEventLiveDetail(source));

      // Go to live section
      this.setViewMode({ mode: 'detail', section: 'live' });
      window.parent.postMessage({ type: 'liveSectionEntered' }, '*');

      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    // ── Utility interna ───────────────────────────────────────────────────────
    _lockScroll() {
      this._scrollY = window.scrollY;
      document.body.style.top = `-${this._scrollY}px`;
      document.body.classList.add('no-scroll');
    },
    _unlockScroll() {
      document.body.classList.remove('no-scroll');
      document.body.style.top = '';
      window.scrollTo(0, this._scrollY || 0);
    },
    /** Invia un postMessage al parent (skin) solo se siamo dentro un iframe. */
    _notifyParent(type, payload) {
      if (typeof window === 'undefined' || window.parent === window) return;
      window.parent.postMessage({ type, ...payload }, '*');
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Material+Icons&display=swap');
.material-icons.big { font-size: var(--font-size-10xl); transition: transform .18s cubic-bezier(.34,1.56,.64,1); }
.material-icons { font-size: var(--font-size-8xl); transition: transform .18s cubic-bezier(.34,1.56,.64,1);}
.menu-bordered {
  background: var(--bg-card, #262939);
  border-bottom: 1px solid var(--border-color);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1200;
}
.slide-menu {


  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit,minmax(0,1fr));
  align-items: flex-end;
  filter: drop-shadow(0px -2px 16px rgba(0,0,0,.12));

}
.menu-box {
  flex: 1 1 0;
  min-width: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 10px 0;
  font-size: var(--font-size-md);
  cursor: pointer;

}
.icon-container { position: relative ; height: 24px; width: 24px}
.icon-mark { display: inline-block; position: relative; transition: transform .18s; height: 24px; width: 24px}
.icon-mark.animating {
  animation: iconScaleBtn 0.32s cubic-bezier(.42,2,.48,1.18);
}
@keyframes iconScaleBtn {
  0% { transform: scale(1);}
  56% { transform: scale(1.42);}
  78% { transform: scale(0.92);}
  100% { transform: scale(1);}
}
.badge {
  position: absolute;
  pointer-events: none;
  top: -6px;
  right: -10px;
  border-radius: 19px;
  min-width: 16px;
  font-size: var(--font-size-sm);
  font-weight: bold;
  line-height: 16px;
  text-align: center;
  padding: 0 5px;

}
.cart-badge { background: var(--color-accent); color: #222; }
.badge-pop { animation: badgePop 0.5s cubic-bezier(.36,1.6,.6,1); }
@keyframes badgePop {
  0%   { transform: scale(1); box-shadow: 0 0 0 0 var(--color-accent); }
  30%  { transform: scale(1.55); box-shadow: 0 0 0 5px transparent; }
  60%  { transform: scale(0.9); }
  100% { transform: scale(1); box-shadow: 0 0 0 0 transparent; }
}
.text {font-size: var(--font-size-md); line-height: 11.5px; text-align: center; color: var(--text-op-50-platform); text-transform: capitalize; width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;}
.menu-box.selected .text, .menu-box.selected .material-icons { color: var(--color-accent); font-weight: bolder }

/* Sidebar modal, cart */
.side-modal {
  position: fixed; top: 0; left: 0; width: 100vw; height: calc(100% - 60px);
  background: var(--sidebar); z-index: 1100; overflow-y: auto;
  display: flex; flex-direction: column;
  transform: translateX(-100%);
  transition: transform .35s cubic-bezier(0.32,0.72,0,1);
}

.side-modal.open { transform: translateX(0); }

.side-modal.cart {
  top: auto;
  bottom: var(--cart-sheet-bottom, 60px);
  width: 100vw;
  height: calc(100% - var(--cart-sheet-bottom, 60px) - 16px);
  padding: 0 !important;
  overflow: hidden !important;
  border-radius: 20px 20px 0 0;
  border-top: 1px solid var(--border-color, rgba(255,255,255,0.08));
  box-shadow: 0 -12px 40px rgba(0, 0, 0, 0.35);
  /* Sotto la bottom nav (1200) così resta sempre visibile */
  z-index: 1150;
  transform: translateY(calc(100% + var(--cart-sheet-bottom, 60px) + 40px));
  transition: transform .38s cubic-bezier(0.32,0.72,0,1);
}
.side-modal.cart.open { transform: translateY(0); }

.cart-sheet-top {
  flex-shrink: 0;
  padding: 8px 16px 4px;
  touch-action: none;
}
.cart-sheet-handle {
  display: block;
  width: 36px;
  height: 4px;
  margin: 0 auto 10px;
  border-radius: 4px;
  background: var(--text-op-50-platform);
  opacity: 0.6;
}
.cart-sheet-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cart-sheet-title {
  font-size: var(--font-size-6xl);
  font-weight: 800;
  text-transform: uppercase;
  color: var(--text-platform);
}
.cart-sheet-close {
  width: 32px;
  height: 32px;
  margin-right: -6px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: var(--text-platform);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s;
}
.cart-sheet-close:active { background: rgba(255,255,255,0.08); }

.side-modal.cart .modal-content {
  flex: 1;
  min-height: 0;
  padding: 0 16px 16px;
  overflow-y: auto !important;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

.mobile-cart-actions-wrap {
  flex-shrink: 0;
  padding: 8px 14px 76px;
  background: var(--sidebar);
  border-top: 1px solid var(--border-color, rgba(255,255,255,0.08));
}

.close-btn {
  background: var(--btn-background);
  color: var(--btn-text);
  border: none; cursor: pointer; padding: 6px; border-radius: 50%;
  height: 40px; width: 40px; display: flex; align-items: center; justify-content: center;
  font-size: var(--font-size-12xl); transition: color .15s;
  position: absolute; top: 10px; right: 10px;
}
.close-btn:hover { color: #ff354d }

.mobile-sidebar-blur-bg {
  position: fixed;
  inset: 0;
  z-index: 1095;
  background: rgba(20, 22, 29, 0.20);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.25s ease;
}
.mobile-sidebar-blur-bg.open {
  opacity: 1;
  pointer-events: auto;
}

/* Header modale mobile */
.modal-header-mobile {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px 10px;
  background: var(--bg-card);
  margin-bottom: 2px;
}
.modal-header-title {
  font-size: var(--font-size-4xl);
  font-weight: 700;
  color: var(--text-platform);
  display: flex;
  align-items: center;
  gap: 8px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.modal-header-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border-radius: 10px;
  background: var(--color-primary-light);
  color: var(--bg-body, #14161d);
  font-size: var(--font-size-xl);
  font-weight: 800;
  line-height: 1;
}
.modal-header-close {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid var(--border-color, rgba(255,255,255,0.15));
  background: transparent;
  color: var(--text-platform);
  font-size: var(--font-size-8xl);
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}
.modal-header-close:hover {
  background: rgba(255,255,255,0.08);
  border-color: var(--text-platform);
}

.top-bar-left-modal {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
.top-bar-left-modal.am{
  padding: 20px 0 20px 14px;
  border-bottom: 1px solid var(--hsla-1);

}

.top-bar-left-modal.am span {
  font-size: var(--font-size-4xl);
  font-weight: 700;
  color: var(--color-accent);
  text-transform: uppercase;
}
.top-bar-left-modal.am .platform-button {
  background: transparent!important;
}

.cart-american-backdrop {
  position: fixed;
  inset: 0;
  z-index: 499;
  background: rgba(0, 0, 0, 0.5);
}

</style>
